import React from 'react'
import Styles from './pageLoader.module.css'
import {Loader} from 'semantic-ui-react'

const PageLoader=(props)=>{
    return(
        <div className={Styles.container} {...props}>
            <Loader active/>
        </div>
    )
}

export default PageLoader